<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Tuinontwerp</h1>

      <h2>Uw tuinontwerp gemaakt door de hovenier</h2>
      <p>
        Een tuinontwerp wordt in de meeste gevallen samen met de hovenier
        gemaakt. Natuurlijk is het handig wanneer u zelf een lijst opstelt zodat
        al uw wensen op een rij staan. Voordat de hovenier aan de slag gaat met
        uw wensen en het tuinontwerp maakt hij een schets van de tuin. Deze
        schets geeft exact de grenzen, de vorm en de afmetingen van uw tuin aan.
        Op de eerste schets begint de hovenier met de verdeling. Hierbij wordt
        aangegeven welke delen van de tuin bestraat worden en welke delen
        onverhard worden. De vlakken die ingedeeld worden als onverhard
        betreffen gras, planten, bomen of vijvers.
      </p>

      <h2>Houd rekening met de zon</h2>
      <p>
        Wanneer u vooraf duidelijk uw wensen voor uw tuin bespreekt met de
        hovenier kan hij de tuin optimaal inrichten. Een hovenier houdt altijd
        rekening met de stand van de zon. Met name omdat u op een mooie lentedag
        lekker in het zonnetje wilt zitten. Wanneer het hoog zomer is, wilt u
        kunnen genieten van de schaduw. Bij het aanleggen van het terras is de
        stand van de zon dus erg belangrijk. De stand van de zon is ook
        belangrijk voor de beplanting. Vergeet overigens ook de wensen van de
        kinderen niet. HovenierVergelijker.nl adviseert u uw kinderen altijd een
        eigen plekje in de tuin te geven waar zij naar hartenlust kunnen spelen.
        Leg bijvoorbeeld een mooi stuk gras aan met daarop een klimtoestel,
        glijbaan of schommel. Fijne bijkomstigheid is dat de kosten van het
        aanleggen van een gazon aanzienlijk lager zijn dan het aanleggen van
        beplanting en dergelijke.
      </p>

      <h2>Routing</h2>
      <p>
        Wellicht heeft u er nog niet bij stil gestaan, maar ook de routing in de
        tuin is belangrijk. Welke paden verbinden welke delen in uw tuin? En
        misschien nog belangrijker: Met welk materiaal verbindt u de diverse
        plekken in de tuin? Dit hangt natuurlijk af van uw voorkeuren. Als u
        vaak buiten wil genieten van lunch of diner is het verstandig een
        makkelijk bewandelbaar pad te maken tussen keuken en terras. Wanneer u
        vaak met potten, pannen, dienbladen en glazen van de keuken naar het
        terras moet lopen is een pad van grind bijvoorbeeld minder geschikt.
      </p>

      <p>
        Daarnaast houdt een hovenier altijd rekening met praktische zaken zoals
        de plaatsing van afvalcontainers en dergelijke. Want u wilt natuurlijk
        niet dat deze constant in het zicht staan. Zet uw wensen op een rij en
        vraag direct gratis offertes aan via HovenierVergelijker.nl
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      title: 'Uw tuinontwerp wordt goedkoper met Hoveniervergelijker.nl',
      description:
        'Een tuinontwerp wordt in de meeste gevallen samen met de hovenier gemaakt. Bespaar op tuinkosten.',
    }
  },
}
</script>
